
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("dKe2f", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7232b894022e706d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5BRby = parcelRequire("5BRby");

var $cA8OV = parcelRequire("cA8OV");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $lawuT = parcelRequire("lawuT");

var $bSS3k = parcelRequire("bSS3k");

var $2Kayt = parcelRequire("2Kayt");
let $7232b894022e706d$var$counter = 0;
class $7232b894022e706d$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.store = props.store ?? (0, $lawuT.store);
    }
    componentDidMount() {
        $7232b894022e706d$var$counter += 1;
        if ($7232b894022e706d$var$counter > 1) throw new Error('Invalid state: Two flag applications mounted at the same time.');
    }
    componentWillUnmount() {
        $7232b894022e706d$var$counter -= 1;
        this.store.dispatch((0, $bSS3k.reset)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cA8OV.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2Kayt.default), null))));
    }
}

});
parcelRegister("cA8OV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0809371ccd3c77a9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");
var // eslint-disable-next-line @typescript-eslint/no-explicit-any,  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
$0809371ccd3c77a9$export$2e2bcd8739ae039 = (0, $kwce8.default).div.withConfig({
    componentId: "h5xpn2-0"
})({
    fontFamily: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $c9TLT.fontFamily,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: `${(0, $c9TLT.fontSize)}px`,
    height: 'inherit',
    letterSpacing: 'normal'
});

});
parcelRegister("c9TLT", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $d7c0be4143e494a4$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $d7c0be4143e494a4$export$7a57f79000377ca2);
$parcel$export(module.exports, "fontSize", () => $d7c0be4143e494a4$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fontFamily", () => $d7c0be4143e494a4$export$a5975749f0374264);
$parcel$export(module.exports, "codeFontFamily", () => $d7c0be4143e494a4$export$356129969ee49c55);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $d7c0be4143e494a4$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $d7c0be4143e494a4$export$7be255094ccdc533);
$parcel$export(module.exports, "layout", () => $d7c0be4143e494a4$export$b3219800bda33a1f);

var $lcnyw = parcelRequire("lcnyw");
const $d7c0be4143e494a4$export$6d8204c2cb2e06b8 = (0, $lcnyw.gridSize)();
const $d7c0be4143e494a4$export$7a57f79000377ca2 = (0, $lcnyw.borderRadius)();
const $d7c0be4143e494a4$export$85e3c3ca0c6fb93 = (0, $lcnyw.fontSize)();
const $d7c0be4143e494a4$export$a5975749f0374264 = (0, $lcnyw.fontFamily)();
const $d7c0be4143e494a4$export$356129969ee49c55 = (0, $lcnyw.codeFontFamily)();
const $d7c0be4143e494a4$export$22dec01f2c854397 = 40;
const $d7c0be4143e494a4$export$dab5ea164c6f81a = 100;
const $d7c0be4143e494a4$export$7be255094ccdc533 = {
    banner: (0, $lcnyw.layers).navigation(),
    card: (0, $lcnyw.layers).card(),
    dialog: (0, $lcnyw.layers).dialog(),
    navigation: (0, $lcnyw.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $lcnyw.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $lcnyw.layers).navigation() - 1,
    layer: (0, $lcnyw.layers).layer(),
    blanket: (0, $lcnyw.layers).blanket(),
    modal: (0, $lcnyw.layers).modal(),
    flag: (0, $lcnyw.layers).flag(),
    spotlight: (0, $lcnyw.layers).spotlight(),
    tooltip: (0, $lcnyw.layers).tooltip(),
    mobileBanner: $d7c0be4143e494a4$export$dab5ea164c6f81a
};
const $d7c0be4143e494a4$export$b3219800bda33a1f = {
    issueIconSize: $d7c0be4143e494a4$export$6d8204c2cb2e06b8 * 2
};

});


parcelRegister("2Kayt", function(module, exports) {

$parcel$export(module.exports, "default", () => $44e99bca81cc042f$export$2e2bcd8739ae039);

var $bSS3k = parcelRequire("bSS3k");

var $2CS8g = parcelRequire("2CS8g");

var $lNNXV = parcelRequire("lNNXV");

var $gCnOc = parcelRequire("gCnOc");

var $d9san = parcelRequire("d9san");
var $44e99bca81cc042f$export$2e2bcd8739ae039 = (0, $lNNXV.connect)((state)=>({
        flags: (0, $2CS8g.getFlags)(state),
        PropBypass: $d9san.PropBypass
    }), {
    onDismissed: (0, $bSS3k.dismiss)
})((0, $gCnOc.default));

});
parcelRegister("2CS8g", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $69569efc8ba5bccf$export$d5815430bcc75df0);
const $69569efc8ba5bccf$export$d5815430bcc75df0 = (state)=>state.flags;

});

parcelRegister("gCnOc", function(module, exports) {

$parcel$export(module.exports, "default", () => $132965d7b936abb5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Yqat = parcelRequire("5Yqat");

var $4ZYEI = parcelRequire("4ZYEI");

var $gUUjF = parcelRequire("gUUjF");

var $ihlUj = parcelRequire("ihlUj");

var $c8KxL = parcelRequire("c8KxL");

var $giAhk = parcelRequire("giAhk");

var $8WuJm = parcelRequire("8WuJm");

var $1YNHg = parcelRequire("1YNHg");
/**
 * Manages and renders flag notifications, supporting dynamic appearances and behaviors. Incorporates
 * internationalization for adaptable message formatting and handles user interactions through
 * configurable actions. Designed to display transient, informative messages to users in a visually
 * consistent manner.
 */ // eslint-disable-next-line jira/react/no-class-components
class $132965d7b936abb5$var$Flags extends (0, $eUqFw.Component) {
    formatMessage(message) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        if (Array.isArray(message)) return formatMessage(...message);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4ZYEI)))(message)) return String(message);
        return formatMessage(message);
    }
    formatActions(actions) {
        return actions ? actions.map((action)=>({
                onClick: action.onClick,
                content: this.formatMessage(action.content),
                href: action.href,
                target: action.target
            })) : undefined;
    }
    renderConfigurableFlag(id, flagConfiguration) {
        const { type: type, title: title, description: description, isAutoDismiss: isAutoDismiss, actions: actions, appearance: appearance, testId: testId, error: error, icon: icon, onDismissed: onDismissed, delayAnnouncement: delayAnnouncement, messageId: messageId, messageType: messageType } = flagConfiguration;
        const defaultedIsAutoDismiss = isAutoDismiss === undefined ? type === 'success' || type === 'info' : isAutoDismiss;
        const isValidType = [
            'success',
            'error',
            'info',
            'warning'
        ].includes(type);
        let formattedDescription = description && this.formatMessage(description);
        if (error) // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
        formattedDescription = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formattedDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ihlUj.ErrorHash), {
            error: error
        }));
        if (isValidType) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1YNHg.JiraCommonFlag), {
            key: id,
            id: id,
            flagType: type,
            icon: icon,
            title: this.formatMessage(title),
            description: formattedDescription,
            isAutoDismiss: defaultedIsAutoDismiss,
            actions: this.formatActions(actions),
            appearance: appearance,
            testId: testId,
            onDismissed: onDismissed,
            messageId: messageId,
            messageType: messageType,
            ...delayAnnouncement && {
                delayAnnouncement: delayAnnouncement
            }
        });
        return null;
    }
    render() {
        const { flags: flags, onDismissed: onDismissed } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "flag",
            sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c8KxL.default), {
            onDismissed: onDismissed
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5Yqat)))(flags.map((flagInstance)=>{
            const { id: id, flag: flag } = flagInstance;
            // @ts-expect-error - TS2339 - Property 'render' does not exist on type 'Flag'.
            if (flag.render !== undefined) {
                // @ts-expect-error - TS2322 - Type 'Flag' is not assignable to type 'FlagCustom'.
                const flagCustom = flag;
                return flagCustom.render({
                    key: id
                });
            }
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'Flag'.
            if (flag.type !== undefined) {
                // @ts-expect-error - TS2322 - Type 'Flag' is not assignable to type 'FlagConfiguration'.
                const flagConfiguration = flag;
                const comp = this.renderConfigurableFlag(id, flagConfiguration);
                if (comp) return comp;
                (0, $gUUjF.default).safeErrorWithoutCustomerData('flags.view', `There was a problem rendering a flag of type: ${flagConfiguration.type}`);
                return null;
            }
            // @ts-expect-error - TS2322 - Type 'Flag' is not assignable to type 'FlagComponent'.
            const FlagComponent = flag;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FlagComponent, {
                key: id,
                id: id,
                onDismissed: onDismissed
            });
        }))));
    }
}
var $132965d7b936abb5$export$2e2bcd8739ae039 = (0, $giAhk.injectIntlV2)($132965d7b936abb5$var$Flags);

});
parcelRegister("5Yqat", function(module, exports) {
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */ function $4596dac18914dac8$var$compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value) result[resIndex++] = value;
    }
    return result;
}
module.exports = $4596dac18914dac8$var$compact;

});

parcelRegister("4ZYEI", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $1c8hB = parcelRequire("1c8hB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $3a3be8dd1917bddc$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3a3be8dd1917bddc$var$isString(value) {
    return typeof value == 'string' || !$1c8hB(value) && $hYEMs(value) && $2OY5s(value) == $3a3be8dd1917bddc$var$stringTag;
}
module.exports = $3a3be8dd1917bddc$var$isString;

});

parcelRegister("ihlUj", function(module, exports) {

$parcel$export(module.exports, "ErrorHash", () => $e823e2ae3cb86cca$export$db1607d938d7ca33);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $iH6c1 = parcelRequire("iH6c1");
const $e823e2ae3cb86cca$var$wrapperStyles = null;
const $e823e2ae3cb86cca$export$db1607d938d7ca33 = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "errors-handling.ui.error-hash"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _18s8qssn _1yt4u49m _11q710p6 _2rko1l7b _ect485st _1wyb16xt _syaz1rr7"
        ])
    }, "ERROR: ", (0, $iH6c1.getErrorHash)(error)));

});

parcelRegister("c8KxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9f08ed55ceefb4$export$2e2bcd8739ae039);

var $kQ0RL = parcelRequire("kQ0RL");
var $4b9f08ed55ceefb4$export$2e2bcd8739ae039 = (0, $kQ0RL.FlagGroup);

});
parcelRegister("kQ0RL", function(module, exports) {

$parcel$export(module.exports, "CommonFlag", () => $2ffdc518941fd08c$export$13d73238a031436b);
$parcel$export(module.exports, "ErrorFlag", () => $2ffdc518941fd08c$export$518ba8e0e60f145f);
$parcel$export(module.exports, "ErrorAutoDismissFlag", () => $2ffdc518941fd08c$export$3f75672bb90a4431);
$parcel$export(module.exports, "InfoFlag", () => $2ffdc518941fd08c$export$6a55b52e74c1e48e);
$parcel$export(module.exports, "SuccessAutoDismissFlag", () => $2ffdc518941fd08c$export$74a3c0748aa31355);
$parcel$export(module.exports, "SuccessFlag", () => $2ffdc518941fd08c$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "WarningFlag", () => $2ffdc518941fd08c$export$23695d8281998f27);
$parcel$export(module.exports, "FlagGroup", () => $2ffdc518941fd08c$export$a2c3479950310d7d);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $5L0Jp = parcelRequire("5L0Jp");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintJiraCommonFlag = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("aiVXY")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintJiraCommonFlag = (0, $7rh0R.lazyAfterPaint)(()=>// eslint-disable-next-line jira/import/webpack-magic-comment-entries
    (parcelRequire("aiVXY")).then(({ JiraCommonFlag: JiraCommonFlag })=>JiraCommonFlag), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/common-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$CommonFlagImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintJiraCommonFlag, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintJiraCommonFlag, props);

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$ForPaintFlagGroup = (0, $7rh0R.lazyForPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2ffdc518941fd08c$var$AfterPaintFlagGroup = (0, $7rh0R.lazyAfterPaint)(// eslint-disable-next-line jira/import/webpack-magic-comment-entries
()=>(parcelRequire("Tabui")), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/flags/src/common/ui/components/group-flag-v2/index.tsx"
});
const $2ffdc518941fd08c$var$FlagGroupImpl = (props)=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$AfterPaintFlagGroup, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$ForPaintFlagGroup, props);
const $2ffdc518941fd08c$export$13d73238a031436b = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, props));
const $2ffdc518941fd08c$export$518ba8e0e60f145f = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        ...props
    }));
const $2ffdc518941fd08c$export$3f75672bb90a4431 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "error",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$6a55b52e74c1e48e = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "info",
        ...props
    }));
const $2ffdc518941fd08c$export$74a3c0748aa31355 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        isAutoDismiss: true,
        ...props
    }));
const $2ffdc518941fd08c$export$93bd4963a1d00fd5 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "success",
        ...props
    }));
const $2ffdc518941fd08c$export$23695d8281998f27 = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$CommonFlagImpl, {
        flagType: "warning",
        ...props
    }));
const $2ffdc518941fd08c$export$a2c3479950310d7d = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2ffdc518941fd08c$var$FlagGroupImpl, props));

});
parcelRegister("aiVXY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('2hmUs'),
            load('bCeK4'),
            load('cCYJs')
        ]);
        const value = parcelRequire('kbpOk');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("2hmUs"),
        load("bCeK4"),
        load("cCYJs")
    ]).then(()=>parcelRequire('kbpOk'));
}

});

parcelRegister("Tabui", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkLGi');
        const value = parcelRequire('jkRT2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkLGi").then(()=>parcelRequire('jkRT2'));
}

});



parcelRegister("giAhk", function(module, exports) {

$parcel$export(module.exports, "injectIntlV2", () => $208f42a3fdc9fe2c$export$440265f0ca78e98e);

var $eUqFw = parcelRequire("eUqFw");

var $lxchL = parcelRequire("lxchL");

var $2qhQi = parcelRequire("2qhQi");

var $1IqwQ = parcelRequire("1IqwQ");
const $208f42a3fdc9fe2c$var$IntlConsumer = (0, $2qhQi.Context).Consumer;
const $208f42a3fdc9fe2c$var$isDisplayableString = (mayBeString)=>typeof mayBeString === 'string' && mayBeString !== '';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $208f42a3fdc9fe2c$var$getDisplayName(Component) {
    if ($208f42a3fdc9fe2c$var$isDisplayableString(Component.displayName)) // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    return Component.displayName;
    if ($208f42a3fdc9fe2c$var$isDisplayableString(Component.name)) return Component.name;
    return 'Component';
}
const $208f42a3fdc9fe2c$export$440265f0ca78e98e = (WrappedComponent, options)=>{
    const { withRef: withRef = false } = options || {};
    const WithIntl = (props)=>{
        const intlRef = (0, $eUqFw.useRef)(null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($208f42a3fdc9fe2c$var$IntlConsumer, null, (intl)=>{
            if (!intl) throw new Error('REACT_INTL_FACADE: React Intl Could not find required `intl` object');
            if (!intlRef.current) intlRef.current = {
                // Now is deprecated since version 2: https://github.com/formatjs/formatjs/issues/1409
                now: ()=>Date.now(),
                // @ts-expect-error We force v5 messages type on v2 type
                messages: intl.messages,
                locale: intl.locale,
                formats: intl.formats,
                formatDate: intl.formatDate,
                formatMessage: intl.formatMessage,
                formatHTMLMessage: (descriptor, values)=>intl.formatMessage(descriptor, values, {
                        ignoreTag: true
                    }),
                formatNumber: intl.formatNumber,
                formatRelative: (date, opts)=>{
                    const { time: time, unit: unit } = (0, $1IqwQ.getRelativeTimeAndUnit)(date);
                    return intl.formatRelativeTime(time, unit, opts);
                },
                formatPlural: intl.formatPlural,
                formatTime: intl.formatTime
            };
            return(// @ts-expect-error - TS2322 - Type 'Diff<LibraryManagedAttributes<Component, ComponentProps<Component>>, InjectIntlVoidProps> & { ...; } & { ...; }' is not assignable to type 'IntrinsicAttributes & LibraryManagedAttributes<Component, PropsWithChildren<P>>'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                ...props,
                intl: intlRef.current,
                ref: withRef ? props.forwardedRef : null
            }));
        });
    };
    // Changed this display name to be capital letter to prevent snapshots from failing, here is the original: https://github.com/formatjs/formatjs/blob/main/packages/react-intl/src/components/injectIntl.tsx#L98
    WithIntl.displayName = `InjectIntl(${$208f42a3fdc9fe2c$var$getDisplayName(WrappedComponent)})`;
    WithIntl.WrappedComponent = WrappedComponent;
    if (withRef) // @ts-expect-error - TS2352 - Conversion of type 'ForwardRefExoticComponent<PropsWithoutRef<WithIntlProps<LibraryManagedAttributes<C, ComponentProps<C>>>> & RefAttributes<...>> & NonReactStatics<...>' to type 'ComponentType<WithIntlProps<LibraryManagedAttributes<C, ComponentProps<C>>>>' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithIntl, {
            ...props,
            forwardedRef: ref
        })), WrappedComponent);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(WithIntl, WrappedComponent);
};

});
parcelRegister("1IqwQ", function(module, exports) {

$parcel$export(module.exports, "getRelativeTimeAndUnit", () => $6a7dda3450af4d49$export$307c4b8ee56b97bb);
$parcel$export(module.exports, "FormattedRelativeV2", () => $6a7dda3450af4d49$export$7317ee2f88fd1276);

var $eUqFw = parcelRequire("eUqFw");

var $9KU0P = parcelRequire("9KU0P");

var $8M1qS = parcelRequire("8M1qS");
const $6a7dda3450af4d49$var$getTimeInUnits = (unitValue)=>{
    const seconds = unitValue / 1000;
    const minutes = seconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    const weeks = days / 7;
    const months = weeks / 4;
    const years = months / 12;
    return {
        seconds: seconds,
        minutes: minutes,
        hours: hours,
        days: days,
        weeks: weeks,
        months: months,
        years: years
    };
};
const $6a7dda3450af4d49$export$307c4b8ee56b97bb = (value, units)=>{
    const timeInMilliseconds = new Date(value);
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    const delta = timeInMilliseconds - Date.now();
    let valueInUnit;
    if (!units) {
        const { value: time, unit: unit } = (0, $9KU0P.selectUnit)(timeInMilliseconds, new Date());
        return {
            time: time,
            unit: unit
        };
    }
    const { seconds: seconds, minutes: minutes, hours: hours, days: days, weeks: weeks, months: months, years: years } = $6a7dda3450af4d49$var$getTimeInUnits(delta);
    switch(units){
        case 'second':
            valueInUnit = seconds;
            break;
        case 'minute':
            valueInUnit = minutes;
            break;
        case 'hour':
            valueInUnit = hours;
            break;
        case 'day':
            valueInUnit = days;
            break;
        case 'week':
            valueInUnit = weeks;
            break;
        case 'month':
            valueInUnit = months;
            break;
        case 'year':
            valueInUnit = years;
            break;
        default:
            valueInUnit = 0;
            break;
    }
    return {
        time: Math.ceil(valueInUnit),
        unit: units
    };
};
const $6a7dda3450af4d49$export$7317ee2f88fd1276 = ({ value: value, units: units, children: children, style: style, format: format, updateInterval: updateInterval })=>{
    const { time: time, unit: unit } = $6a7dda3450af4d49$export$307c4b8ee56b97bb(value, units);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8M1qS.default), {
        value: time,
        unit: unit,
        numeric: style === 'numeric' ? 'always' : 'auto',
        format: format,
        updateIntervalInSeconds: updateInterval
    }, children);
};
$6a7dda3450af4d49$export$7317ee2f88fd1276.displayName = 'FormattedRelative';

});


// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("1YNHg", function(module, exports) {

$parcel$export(module.exports, "JiraCommonFlag", () => $115f5e3393fc07fb$export$1d9a3324fc0eb52);

var $eUqFw = parcelRequire("eUqFw");

var $jGBLd = parcelRequire("jGBLd");

var $1ojp3 = parcelRequire("1ojp3");

var $grBG3 = parcelRequire("grBG3");
const $115f5e3393fc07fb$export$1d9a3324fc0eb52 = (props)=>{
    if ((0, $jGBLd.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ojp3.ChoreographerCommonFlag), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $grBG3.default), rest);
};

});
parcelRegister("jGBLd", function(module, exports) {

$parcel$export(module.exports, "shouldBeChoreographed", () => $38eaf8660dcaa871$export$a8ba9111c7eec9ac);

var $eI5EY = parcelRequire("eI5EY");

var $EbGpR = parcelRequire("EbGpR");
function $38eaf8660dcaa871$export$a8ba9111c7eec9ac(props) {
    return (0, $eI5EY.fg)('po-jira-choreographer-api-integration') ? !!props?.messageType && (0, $EbGpR.IntegratedChoreographerMessageTypesEnum).includes(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    props.messageType) : false;
}

});
parcelRegister("EbGpR", function(module, exports) {

$parcel$export(module.exports, "IntegratedChoreographerMessageTypesEnum", () => $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0);
const $e5c6b031155cf9c2$export$94e85cf3348f045a = {
    ENGAGEMENT: 'engagement',
    MARKETING: 'marketing',
    TRANSACTIONAL: 'transactional'
};
const $e5c6b031155cf9c2$export$dbe9e38c9d6f26d0 = [
    $e5c6b031155cf9c2$export$94e85cf3348f045a.ENGAGEMENT,
    $e5c6b031155cf9c2$export$94e85cf3348f045a.MARKETING
];

});


parcelRegister("1ojp3", function(module, exports) {

$parcel$export(module.exports, "ChoreographerCommonFlag", () => $cf99a705c3566f5a$export$ef12cdd486f28a7a);

var $kytz8 = parcelRequire("kytz8");

var $grBG3 = parcelRequire("grBG3");
const $cf99a705c3566f5a$export$ef12cdd486f28a7a = (0, $kytz8.withChoreographedRender)((0, $grBG3.default));

});
parcelRegister("kytz8", function(module, exports) {

$parcel$export(module.exports, "withChoreographedRender", () => $d60c6f7c92c4fa11$export$c1160fdac17030e);

var $eUqFw = parcelRequire("eUqFw");

var $6uNFR = parcelRequire("6uNFR");
function $d60c6f7c92c4fa11$export$c1160fdac17030e(Component, options) {
    function ChoreographedComponent({ messageId: messageId, onMessageDisposition: onMessageDisposition, ...props }) {
        const shouldRender = (0, $6uNFR.useChoreographedRender)({
            messageId: messageId,
            onMessageDisposition: onMessageDisposition
        });
        if (shouldRender) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, props);
        if (options && options.toggleableProp) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const toggleableComponentProps = {
                ...props,
                [options.toggleableProp]: false
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, toggleableComponentProps);
        }
        return null;
    }
    ChoreographedComponent.displayName = `Choreographed${Component.displayName ?? 'Component'}`;
    return ChoreographedComponent;
}

});
parcelRegister("6uNFR", function(module, exports) {

$parcel$export(module.exports, "useChoreographer", () => $dbff780bfca374d0$export$9f0e2488ffd90f11);
$parcel$export(module.exports, "useChoreographedRender", () => $dbff780bfca374d0$export$2cfd68294be82811);

var $eUqFw = parcelRequire("eUqFw");

var $9RC8H = parcelRequire("9RC8H");

var $6rW04 = parcelRequire("6rW04");

var $38OPi = parcelRequire("38OPi");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $dbff780bfca374d0$var$environment = (0, $38OPi.toEnvironment)((0, $6rW04.default)('ajs-environment')) ?? 'prod';
/**
 * Stupid hack alert: useChoreographer is throwing a TS compiler error about using MessageEventType
 * internally, and not being able to resolve that name... The usual fix for this is to add the
 * offending type to the project's exports, and then import it here so that the compiler has some
 * knowledge of what that type definition is... In this case, it doesn't seem to be working, but
 * for whatever reason, I can cast the choreographerFactory's return type using nothing more than
 * the information provided by the ReturnType<typeof choreographerFactory> type above, and then
 * define the useChoreographer type as an args list that conforms to its Parameters list, and a
 * return type that conforms to its ReturnType, and that seems to work just fine. Hopefully, somebody
 * can figure out what's going wrong here, and remove this idiocy in favor of something more sane.
 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const { plugin: $dbff780bfca374d0$export$27fff9a48cfe124b, useChoreographer: $dbff780bfca374d0$export$9f0e2488ffd90f11 } = (0, $9RC8H.choreographerFactory)((0, $9RC8H.ProductIds).JIRA, $dbff780bfca374d0$var$environment);
const $dbff780bfca374d0$export$2cfd68294be82811 = ({ messageId: messageId, onMessageDisposition: onMessageDisposition })=>{
    const [shouldRender, setShouldRender] = (0, $eUqFw.useState)(false);
    const { startMessage: startMessage, stopMessage: stopMessage } = $dbff780bfca374d0$export$9f0e2488ffd90f11(messageId, {
        start: ()=>setShouldRender(true)
    });
    (0, $eUqFw.useEffect)(()=>{
        const startMessageAsync = async ()=>{
            const disposition = await startMessage();
            onMessageDisposition?.(disposition);
        };
        startMessageAsync();
        return ()=>{
            stopMessage();
        };
    }, [
        onMessageDisposition,
        startMessage,
        stopMessage
    ]);
    return shouldRender;
};

});


parcelRegister("grBG3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2d6efb14273248$export$2e2bcd8739ae039);
/* common-flag.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3Oaez = parcelRequire("3Oaez");
var $4GEic = parcelRequire("4GEic");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dwpgR = parcelRequire("dwpgR");

var $eoOIK = parcelRequire("eoOIK");
const $6b2d6efb14273248$export$b020578ce674a70f = 'platform.ui.flags.common.ui.common-flag-v2';
/**
 * Renders a flag component with dynamic behavior, automatically choosing between auto-dismissing
 * and standard modes based on properties. It dynamically selects an appropriate icon and supports
 * internationalization and accessibility, making it versatile for various use cases.
 */ const $6b2d6efb14273248$var$CommonFlag = (props)=>{
    const { flagType: flagType, icon: icon, delayAnnouncement: delayAnnouncement, ...internalFlagProps } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const StyledIcon = internalFlagProps.appearance ? (0, $dwpgR.boldIconMap)[flagType] : (0, $dwpgR.iconMap)[flagType];
    let flagElement;
    if (internalFlagProps.isAutoDismiss === true) {
        const { isAutoDismiss: isAutoDismiss, ...autoDismissFlagProps } = internalFlagProps;
        flagElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Oaez.default), {
            testId: `${$6b2d6efb14273248$export$b020578ce674a70f}-auto-dismiss`,
            ...autoDismissFlagProps,
            icon: icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledIcon, {
                label: formatMessage((0, $eoOIK.messages)[flagType])
            }) ?? null
        });
    } else {
        const { isAutoDismiss: isAutoDismiss, ...flagProps } = internalFlagProps;
        flagElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4GEic.default), {
            testId: $6b2d6efb14273248$export$b020578ce674a70f,
            ...flagProps,
            ...delayAnnouncement && {
                delayAnnouncement: delayAnnouncement
            },
            icon: icon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledIcon, {
                label: formatMessage((0, $eoOIK.messages)[flagType])
            }) ?? null
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b2d6efb14273248$var$Container, {
        role: "status",
        "aria-live": "polite",
        ...internalFlagProps.testId !== undefined ? {
            'data-test-id': internalFlagProps.testId
        } : {}
    }, flagElement);
};
var $6b2d6efb14273248$export$2e2bcd8739ae039 // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $6b2d6efb14273248$var$CommonFlag;
const $6b2d6efb14273248$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_slp31hna",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dwpgR", function(module, exports) {

$parcel$export(module.exports, "iconMap", () => $eb890f2afc8b830a$export$6d49a893c897b0cc);
$parcel$export(module.exports, "boldIconMap", () => $eb890f2afc8b830a$export$6c71c95b1e390472);

var $ew0AN = parcelRequire("ew0AN");
const $eb890f2afc8b830a$export$6d49a893c897b0cc = {
    error: (0, $ew0AN.IconError),
    success: (0, $ew0AN.IconSuccess),
    info: (0, $ew0AN.IconInfo),
    warning: (0, $ew0AN.IconWarning)
};
const $eb890f2afc8b830a$export$6c71c95b1e390472 = {
    error: (0, $ew0AN.BoldIconError),
    success: (0, $ew0AN.BoldIconSuccess),
    info: (0, $ew0AN.BoldIconInfo),
    warning: (0, $ew0AN.BoldIconWarning)
};

});
parcelRegister("ew0AN", function(module, exports) {

$parcel$export(module.exports, "IconError", () => $82fb784a250c97db$export$66493327321323ad);
$parcel$export(module.exports, "IconSuccess", () => $82fb784a250c97db$export$9cae035d1b6ae1dc);
$parcel$export(module.exports, "IconInfo", () => $82fb784a250c97db$export$340bfce9b4df026b);
$parcel$export(module.exports, "IconWarning", () => $82fb784a250c97db$export$5be70e40251e6f9b);
$parcel$export(module.exports, "BoldIconError", () => $82fb784a250c97db$export$4d6c0ef1e9e095ae);
$parcel$export(module.exports, "BoldIconSuccess", () => $82fb784a250c97db$export$23fdc8fccd51d997);
$parcel$export(module.exports, "BoldIconInfo", () => $82fb784a250c97db$export$4c05116eb19cc3aa);
$parcel$export(module.exports, "BoldIconWarning", () => $82fb784a250c97db$export$522238647b7d04fc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");
const $82fb784a250c97db$export$66493327321323ad = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82fb784a250c97db$export$8f314e512d92575f, {
        iconColor: `var(--ds-icon-danger, ${(0, $PdmhA).R300})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: label
    }));
const $82fb784a250c97db$export$9cae035d1b6ae1dc = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82fb784a250c97db$export$8f314e512d92575f, {
        iconColor: `var(--ds-icon-success, ${(0, $PdmhA).G300})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        label: label
    }));
const $82fb784a250c97db$export$340bfce9b4df026b = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82fb784a250c97db$export$8f314e512d92575f, {
        iconColor: `var(--ds-icon-discovery, ${(0, $PdmhA).P300})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        label: label
    }));
const $82fb784a250c97db$export$5be70e40251e6f9b = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($82fb784a250c97db$export$8f314e512d92575f, {
        iconColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y300})`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: label
    }));
const $82fb784a250c97db$export$4d6c0ef1e9e095ae = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: label,
        secondaryColor: `var(--ds-icon-danger, ${(0, $PdmhA).R300})`
    });
const $82fb784a250c97db$export$23fdc8fccd51d997 = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        label: label,
        secondaryColor: `var(--ds-icon-success, ${(0, $PdmhA).G300})`
    });
const $82fb784a250c97db$export$4c05116eb19cc3aa = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        label: label,
        secondaryColor: `var(--ds-icon-discovery, ${(0, $PdmhA).P300})`
    });
const $82fb784a250c97db$export$522238647b7d04fc = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: label,
        secondaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y300})`
    });
const $82fb784a250c97db$export$8f314e512d92575f = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { iconColor: iconColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1weumv": (0, $9t7rW.default)(__cmplp.iconColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1kah",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aWvIp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f77ec2b05210607$var$_react = $7f77ec2b05210607$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7f77ec2b05210607$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f77ec2b05210607$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $7f77ec2b05210607$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$7f77ec2b05210607$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $7f77ec2b05210607$var$_default = $7f77ec2b05210607$var$CheckCircleIcon;
module.exports.default = $7f77ec2b05210607$var$_default;

});

parcelRegister("2bv8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1974c390fcca76c2$var$_react = $1974c390fcca76c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1974c390fcca76c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1974c390fcca76c2$var$InfoIcon = (props)=>/*#__PURE__*/ $1974c390fcca76c2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12z" fill="currentColor"/><rect fill="inherit" x="11" y="10" width="2" height="7" rx="1"/><circle fill="inherit" cx="12" cy="8" r="1"/></g></svg>`
    }, props));
$1974c390fcca76c2$var$InfoIcon.displayName = 'InfoIcon';
var $1974c390fcca76c2$var$_default = $1974c390fcca76c2$var$InfoIcon;
module.exports.default = $1974c390fcca76c2$var$_default;

});



parcelRegister("eoOIK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8485940862529e44$export$defe85febe8b728c);
// Should not remove this disabled-line and don't run eslint --fix for this file
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $8485940862529e44$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    error: {
        "id": "platform.flags.common.components.common-flag.error",
        "defaultMessage": "Error"
    },
    success: {
        "id": "platform.flags.common.components.common-flag.success",
        "defaultMessage": "Success"
    },
    info: {
        "id": "platform.flags.common.components.common-flag.info",
        "defaultMessage": "Information"
    },
    warning: {
        "id": "platform.flags.common.components.common-flag.warning",
        "defaultMessage": "Warning"
    }
});

});





parcelRegister("d9san", function(module, exports) {

$parcel$export(module.exports, "PropBypass", () => $68ce62dbfd3c2566$export$84bef06589f4b13a);
const $68ce62dbfd3c2566$export$84bef06589f4b13a = ({ children: children, key: key, ...props })=>children(props);

});




//# sourceMappingURL=async-flags.3621e05c.js.map
